<template>
  <process-menu :items="serviceProviders" />
</template>

<script>
import ProcessMenu from '@/components/ProcessMenu'

export default {
  components: { ProcessMenu },
  data: () => ({
    serviceProviders: [
      {
        src: require('@/assets/img/service-providers/car-rental.png'),
        heading: 'Car Rental Vendors',
        text: 'Get your car rental reports on trips made and from which vendors.',
        link: { name: 'CarRentalVendor' },
        roles: ['internalAssessor', 'claimOfficer'],
      },
      {
        src: require('@/assets/img/service-providers/garages.png'),
        heading: 'Garage',
        text: 'Get your garage reports through various clusters & repair costs.',
        link: { name: 'GarageTable' },
        roles: ['internalAssessor', 'claimOfficer'],
      },
      {
        src: require('@/assets/img/service-providers/windscreen-fitter.png'),
        heading: 'Windscreen Fitters',
        text: 'Get reports of the windscreen fitters on the services rendered.',
        link: { name: 'WindscreenFitters' },
        roles: ['internalAssessor', 'claimOfficer'],
      },
      {
        src: require('@/assets/img/service-providers/tow-trucks.png'),
        heading: 'Tow Trucks',
        text: 'For Vehicles with low impact damages and need quick repairs',
        link: '/dashboard',
        roles: ['internalAssessor', 'claimOfficer'],
      },
      {
        src: require('@/assets/img/service-providers/external-assessors.png'),
        heading: 'Spot Assessors',
        text: 'Get reports of the accident scene and the service provision.',
        link: '/dashboard',
        roles: ['internalAssessor', 'claimOfficer'],
      },
    ],
  }),
}
</script>
